module.exports = __webpack_public_path__ + "assets/img/32_639.091f466b.jpg";